import { Modal } from "antd";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import config from "../../config";

const LatestLocationMap = ({
  isOpen,
  onOk,
  onCancel,
  latestLocationCoordinates,
}) => {
  const mapCenter = {
    lat: latestLocationCoordinates.lat,
    lng: latestLocationCoordinates.lng,
  }; // San Francisco
  const mapZoom = 15;

  // Marker position
  const markerPosition = {
    lat: latestLocationCoordinates.lat,
    lng: latestLocationCoordinates.lng,
  };

  return (
    <>
      <Modal
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        width={450}
        footer={null}
        className="map-modal"
      >
        {/* <img
            src="images/map.png"
            alt="QR-code"
            className="w-full"
          /> */}
        <LoadScript googleMapsApiKey={config.GOOGLEMAPAPIKEY}>
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "400px" }}
            center={mapCenter}
            zoom={mapZoom}
          >
            {/* Place the Marker on the map */}
            <Marker position={markerPosition} />
          </GoogleMap>
        </LoadScript>
      </Modal>
    </>
  );
};
export default LatestLocationMap;
